import { ResponseDTO } from './response-dto';

export interface ReadContextRoleScopePickerValidationResponseDTO extends ResponseDTO {
    msg?: string;
}
